import LockIcon from '@mui/icons-material/Lock';
import { StyledCard, StyledRoot, StyledTypography, Wrapper } from './Section.styles';

interface SectionProps {
  title: string;
  children: React.ReactNode;
}

const Section = ({ title, children }: SectionProps) => (
  <StyledRoot>
    <Wrapper>
      <StyledTypography>{title}</StyledTypography>
      <LockIcon fontSize="small" color="disabled" />
    </Wrapper>

    <StyledCard>{children}</StyledCard>
  </StyledRoot>
);

export default Section;
